(function webpackUniversalModuleDefinition(e, r) {
  if (typeof exports === "object" && typeof module === "object") module.exports = r(require("lodash-es/isError"), require("rxjs"), require("tslib"));else if (typeof define === "function" && define.amd) define(["lodash-es/isError", "rxjs", "tslib"], r);else if (typeof exports === "object") exports["@mq/aurora-logging"] = r(require("lodash-es/isError"), require("rxjs"), require("tslib"));else e["@mq/aurora-logging"] = r(e["lodash-es/isError"], e["rxjs"], e["tslib"]);
})(typeof self !== "undefined" ? self : this, function (e, r, n) {
  return function () {
    "use strict";

    var t = {
      372: function (r) {
        r.exports = e;
      },
      435: function (e) {
        e.exports = r;
      },
      780: function (e) {
        e.exports = n;
      }
    };
    var o = {};
    function __webpack_require__(e) {
      var r = o[e];
      if (r !== undefined) {
        return r.exports;
      }
      var n = o[e] = {
        exports: {}
      };
      t[e](n, n.exports, __webpack_require__);
      return n.exports;
    }
    !function () {
      __webpack_require__.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        __webpack_require__.d(r, {
          a: r
        });
        return r;
      };
    }();
    !function () {
      __webpack_require__.d = function (e, r) {
        for (var n in r) {
          if (__webpack_require__.o(r, n) && !__webpack_require__.o(e, n)) {
            Object.defineProperty(e, n, {
              enumerable: true,
              get: r[n]
            });
          }
        }
      };
    }();
    !function () {
      __webpack_require__.o = function (e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
      };
    }();
    !function () {
      __webpack_require__.r = function (e) {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          });
        }
        Object.defineProperty(e, "__esModule", {
          value: true
        });
      };
    }();
    var i = {};
    !function () {
      __webpack_require__.r(i);
      __webpack_require__.d(i, {
        BroadcastChannelAppender: function () {
          return v;
        },
        BroadcastChannelAppenderServer: function () {
          return d;
        },
        ConsoleAppender: function () {
          return l;
        },
        DEFAULT_APPENDER: function () {
          return L;
        },
        LD_VERBOSE_FLAG: function () {
          return _;
        },
        LogLevel: function () {
          return e;
        },
        Logger: function () {
          return p;
        },
        LoggerFactory: function () {
          return h;
        },
        TS_W_WBPK_I_LOG_EVENT: function () {
          return t;
        },
        TS_W_WBPK_LOGGER: function () {
          return n;
        },
        TS_W_WBPK_LOGGER_APPENDER: function () {
          return c;
        },
        TS_W_WBPK_LOGGER_FACTORY_CONFIG: function () {
          return b;
        },
        TransformingLoggerAppender: function () {
          return u;
        },
        logLevelCompare: function () {
          return logLevelCompare;
        },
        loggerFactory: function () {
          return C;
        },
        toSerializable: function () {
          return toSerializable;
        },
        topicAppender: function () {
          return w;
        }
      });
      var e;
      (function (e) {
        e["DEBUG"] = "DEBUG";
        e["INFO"] = "INFO";
        e["WARN"] = "WARN";
        e["ERROR"] = "ERROR";
      })(e || (e = {}));
      var r = new Map([[e.DEBUG, 0], [e.INFO, 10], [e.WARN, 30], [e.ERROR, 40]]);
      function logLevelCompare(e, n) {
        var t = r.get(e);
        var o = r.get(n);
        if (t !== undefined && o !== undefined) {
          return t - o;
        } else {
          throw new Error("Unrecognized log levels " + t + " " + o);
        }
      }
      var n = 1;
      var t = 1;
      function toSerializableMeta(e) {
        var r = {};
        if (e.error) {
          r = {
            error: e.error.toString()
          };
        }
        r = Object.assign(r, {
          data: e.data
        });
        return r;
      }
      function stringifyMsg(e) {
        if (typeof e === "object") {
          try {
            return JSON.stringify(e);
          } catch (r) {
            return e.toString();
          }
        } else {
          return e.toString();
        }
      }
      function toSerializable(e) {
        return {
          msg: stringifyMsg(e.msg),
          time: e.time,
          level: e.level,
          loggerName: e.loggerName,
          meta: e.meta && toSerializableMeta(e.meta)
        };
      }
      var o = __webpack_require__(780);
      var a = __webpack_require__(372);
      var s = __webpack_require__.n(a);
      var p = function () {
        function Logger(e, r, n) {
          this.name = e;
          this.cfgResolver = r;
          this.appenderResolver = n;
        }
        Logger.prototype.log = function (e, r, n) {
          var t = {
            msg: r,
            time: this.currentTime(),
            level: e,
            loggerName: this.name,
            meta: this.metaWithDefaultData(n)
          };
          this.logEvent(t);
        };
        Logger.prototype.debug = function (r, n) {
          this.log(e.DEBUG, r, n);
        };
        Logger.prototype.info = function (r, n) {
          this.log(e.INFO, r, n);
        };
        Logger.prototype.warn = function (r, n) {
          this.log(e.WARN, r, this.convertErrToMeta(n));
        };
        Logger.prototype.error = function (r, n) {
          this.log(e.ERROR, r, this.convertErrToMeta(n));
        };
        Logger.prototype.logEvent = function (r) {
          var n = this;
          var t = this.cfgResolver(this.name);
          var o = e[t.level];
          if (o === undefined) {
            o = e.INFO;
          }
          try {
            if (logLevelCompare(r.level, o) >= 0) {
              t.appenders.forEach(function (e) {
                var t = n.appenderResolver(e);
                if (t) {
                  t.append(r);
                }
              });
            }
          } catch (e) {
            console.error("Failed to log event", e);
          }
        };
        Logger.prototype.currentTime = function () {
          return new Date();
        };
        Logger.prototype.convertErrToMeta = function (e) {
          if (s()(e)) {
            return {
              error: e
            };
          } else {
            return e;
          }
        };
        Logger.prototype.defaultMetaData = function () {
          return {
            __location: self.location.pathname
          };
        };
        Logger.prototype.metaWithDefaultData = function (e) {
          if (!e) {
            return {
              data: this.defaultMetaData()
            };
          } else {
            return {
              error: e.error,
              data: (0, o.__assign)((0, o.__assign)({}, this.defaultMetaData()), e.data)
            };
          }
        };
        return Logger;
      }();
      var u = function () {
        function TransformingLoggerAppender(e, r) {
          this.delegate = e;
          this.transformer = r;
        }
        TransformingLoggerAppender.prototype.append = function (e) {
          this.delegate.append(this.transformer(e));
        };
        return TransformingLoggerAppender;
      }();
      var c = 1;
      var l = function () {
        function ConsoleAppender() {}
        ConsoleAppender.prototype.append = function (r) {
          if (false) {}
          var n = console.log;
          if (r.level === e.DEBUG) {
            n = console.debug;
          } else if (r.level === e.INFO) {
            n = console.log;
          } else if (r.level === e.WARN) {
            n = console.warn;
          } else if (r.level === e.ERROR) {
            n = console.error;
          }
          var t = [];
          var o = typeof r.time === "string" ? r.time : r.time.toISOString();
          t.push("[" + o + "][" + r.level + "][" + r.loggerName + "]");
          t.push(r.msg);
          if (r.meta) {
            t.push(r.meta);
          }
          n.apply(void 0, t);
        };
        return ConsoleAppender;
      }();
      var g = __webpack_require__(435);
      var f = function () {
        function TopicAppender(e, r) {
          this.subscriptions = new Map();
          this.topic = new g.ReplaySubject(e, r);
        }
        TopicAppender.prototype.append = function (e) {
          this.topic.next(e);
        };
        TopicAppender.prototype.subscribe = function (e) {
          var r = this;
          console.log("Subscribing appender: " + e.key + ", level: " + e.level);
          var n = this.topic.subscribe({
            next: function (n) {
              var t = (r.subscriptions.get(e.key) || {
                cfg: e
              }).cfg;
              var o = t.level;
              if (!o || logLevelCompare(n.level, o) >= 0) {
                t.appender.append(n);
              }
            },
            error: function (e) {
              console.log("Topic Appender Error", e);
            }
          });
          this.subscriptions.set(e.key, {
            cfg: e,
            subscription: n
          });
        };
        TopicAppender.prototype.updateLevel = function (e, r) {
          console.log("Updating level: " + e + ", level: " + r);
          var n = this.subscriptions.get(e);
          if (n) {
            this.subscriptions.set(e, (0, o.__assign)((0, o.__assign)({}, n), {
              cfg: (0, o.__assign)((0, o.__assign)({}, n.cfg), {
                level: r
              })
            }));
          }
        };
        TopicAppender.prototype.unsubscribe = function (e) {
          var r = this.subscriptions.get(e);
          if (r) {
            r.subscription.unsubscribe();
            this.subscriptions.delete(e);
            return true;
          } else {
            return false;
          }
        };
        return TopicAppender;
      }();
      var d = function () {
        function BroadcastChannelAppenderServer(e, r, n) {
          this.bc = new BroadcastChannel(e);
          var t = new f(r, n);
          this.topicAppender = t;
          this.bc.onmessage = function (e) {
            t.append(e.data);
          };
          console.log("[BroadcastChannelAppenderServer] subscribed to topic " + e);
        }
        BroadcastChannelAppenderServer.prototype.subscribe = function (e, r) {
          console.log("[BroadcastChannelAppenderServer] adding appender: " + e);
          this.topicAppender.subscribe({
            key: e,
            appender: r
          });
        };
        BroadcastChannelAppenderServer.prototype.unsubscribe = function (e) {
          return this.topicAppender.unsubscribe(e);
        };
        return BroadcastChannelAppenderServer;
      }();
      var v = function () {
        function BroadcastChannelAppender(e) {
          console.log("[BroadcastChannelAppender] publishing on topic: " + e);
          this.channel = new BroadcastChannel(e);
        }
        BroadcastChannelAppender.prototype.append = function (e) {
          this.channel.postMessage(e);
        };
        return BroadcastChannelAppender;
      }();
      var _ = "uip-log-verbose";
      var h = function () {
        function LoggerFactory(e) {
          this.appenders = new Map(e.appenders.map(function (e) {
            return [e.name, e.appender];
          }));
          this.loggerCfgs = new Map(e.loggers.map(function (e) {
            return [e.name, e];
          }));
          this.loggers = new Map();
          this.validateConfig();
        }
        LoggerFactory.prototype.getLogger = function (e) {
          var r = this.loggers.get(e);
          if (r === undefined) {
            r = this.createLogger(e);
          }
          return r;
        };
        LoggerFactory.prototype.updateLevel = function (e, r) {
          var n = this.resolveClosestLoggerCfg(e);
          var t = this.loggerCfgs.get(n);
          var o = {
            level: r,
            name: e,
            appenders: t.appenders
          };
          this.loggerCfgs.set(e, o);
        };
        LoggerFactory.prototype.createLogger = function (e) {
          var r = this;
          var n = new p(e, function (e) {
            var n = r.resolveClosestLoggerCfg(e);
            return r.loggerCfgs.get(n);
          }, function (e) {
            return r.appenders.get(e);
          });
          this.loggers.set(e, n);
          return n;
        };
        LoggerFactory.prototype.resolveClosestLoggerCfg = function (e) {
          var r;
          var n = 0;
          Array.from(this.loggerCfgs.keys()).forEach(function (t) {
            if (e.startsWith(t)) {
              if (t.length > n) {
                n = t.length;
                r = t;
              }
            }
          });
          if (r === undefined) {
            r = LoggerFactory.ROOT_LOGGER;
          }
          return r;
        };
        LoggerFactory.prototype.validateConfig = function () {
          var r = this;
          Array.from(this.loggerCfgs.values()).forEach(function (n) {
            var t = e[n.level];
            if (t === undefined) {
              throw new Error("Invalid log level: " + n.level);
            }
            n.appenders.forEach(function (e) {
              var n = r.appenders.get(e);
              if (n === undefined) {
                throw new Error("No appender found with name " + e);
              }
            });
          });
        };
        LoggerFactory.ROOT_LOGGER = "root";
        return LoggerFactory;
      }();
      var b = 1;
      var y = 1e3;
      var m = 3e4;
      var L = "defaultAppender";
      var A = new f(y, m);
      A.subscribe({
        key: L,
        level: e.INFO,
        appender: new l()
      });
      var E = new h({
        loggers: [{
          name: "root",
          level: "INFO",
          appenders: ["topicAppender"]
        }],
        appenders: [{
          name: "topicAppender",
          appender: A
        }]
      });
      var w = A;
      var C = E;
    }();
    return i;
  }();
});